import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { Rider } from './rider';
import { OrganizationRiderPool } from './organization-rider-pool';

@inheritSerialization(AbstractModel)
export class OrganizationRider extends AbstractModel {
  @autoserialize
  organizationId: number;

  @autoserializeAs(Rider)
  rider: Rider;

  @autoserialize
  organizationName: string;

  @autoserialize
  partnerIdentifier: string;

  @autoserialize
  accessibilityRequirements: string;

  @autoserialize
  riderEmailDeclined: boolean;

  @autoserializeAs(Date)
  riderEmailDeclinedAt: Date;

  @autoserialize
  createdByUserId: number;

  @autoserialize
  eligible: boolean;

  @autoserialize
  active: boolean;

  @autoserialize
  balance: number;

  @autoserialize
  pcaApproved: boolean;

  @autoserialize
  firstName: string;

  @autoserialize
  middleName: string;

  @autoserialize
  lastName: string;

  @autoserialize
  emailAddress: string;

  @autoserialize
  emailAddressVerified: boolean;

  @autoserialize
  phoneNumber: string;

  @autoserializeAs(Date)
  dateOfBirth: Date;

  @autoserialize
  smsEnabledPhone: boolean;

  @autoserialize
  proofed: boolean;

  @autoserializeAs(OrganizationRiderPool)
  organizationRiderPool: OrganizationRiderPool;

  constructor() {
    super();
    this.rider = new Rider();
  }

  static OnSerialized(instance: OrganizationRider, json: any): void {
    if (!isNullOrUndefined(instance.riderEmailDeclinedAt)) {
      json.riderEmailDeclinedAt = DateUtil.serializeDate(instance.riderEmailDeclinedAt);
    }

    if (!isNullOrUndefined(instance.dateOfBirth)) {
      json.dateOfBirth = DateUtil.serializeLocalDate(instance.dateOfBirth);
    }

    if (!isNullOrUndefined(instance.firstName)) {
      json.firstName = instance.firstName.trim();
    }

    if (!isNullOrUndefined(instance.middleName)) {
      json.middleName = instance.middleName.trim();
    }

    if (!isNullOrUndefined(instance.lastName)) {
      json.lastName = instance.lastName.trim();
    }

    if (!isNullOrUndefined(instance.emailAddress)) {
      json.emailAddress = instance.emailAddress.toLowerCase().trim();
    }
  }

  static OnDeserialized(instance: OrganizationRider, json: any): void {
    if (!isNullOrUndefined(json['riderEmailDeclinedAt'])) {
      instance.riderEmailDeclinedAt = DateUtil.deserializeDate(json['riderEmailDeclinedAt']);
    }

    if (!isNullOrUndefined(json['dateOfBirth'])) {
      instance.dateOfBirth = DateUtil.deserializeLocalDate(json['dateOfBirth']);
    }
  }
}
